import type { ReportTemplate as ReportTemplateV1 } from "./version/report-v1";
import { migrateV1ToV2, type ReportTemplate as ReportTemplateV2 } from "./version/report-v2";
import { migrateV2ToV3, type ReportTemplate as ReportTemplateV3 } from "./version/report-v3";
import { migrateV3ToV4, type ReportTemplate as ReportTemplateV4 } from "./version/report-v4";
import { migrateV4ToV5, type ReportTemplate as ReportTemplateV5 } from "./version/report-v5";
import { migrateV5ToV6, type ReportTemplate as ReportTemplateV6 } from "./version/report-v6";
import { migrateV6ToV7, type ReportTemplate as ReportTemplateV7 } from "./version/report-v7";
import { migrateV7ToV8, type ReportTemplate as ReportTemplateV8 } from "./version/report-v8";
import { migrateV8ToV9, type ReportTemplate as ReportTemplateV9 } from "./version/report-v9";
import { migrateV9ToV10, type ReportTemplate as ReportTemplateV10 } from "./version/report-v10";
import { migrateV10ToV11, type ReportTemplate as ReportTemplateV11 } from "./version/report-v11";
import { migrateV11ToV12, type ReportTemplate as ReportTemplateV12 } from "./version/report-v12";
import { migrateV12ToV13, type ReportTemplate as ReportTemplateLatest } from "./version/report-v13";

export * from "./version/report-v13";

type MigrateFns = {
	2: (reportTemplate: ReportTemplateV1) => ReportTemplateV2;
	3: (reportTemplate: ReportTemplateV2) => ReportTemplateV3;
	4: (reportTemplate: ReportTemplateV3) => ReportTemplateV4;
	5: (reportTemplate: ReportTemplateV4) => ReportTemplateV5;
	6: (reportTemplate: ReportTemplateV5) => ReportTemplateV6;
	7: (reportTemplate: ReportTemplateV6) => ReportTemplateV7;
	8: (reportTemplate: ReportTemplateV7) => ReportTemplateV8;
	9: (reportTemplate: ReportTemplateV8) => ReportTemplateV9;
	10: (reportTemplate: ReportTemplateV9) => ReportTemplateV10;
	11: (reportTemplate: ReportTemplateV10) => ReportTemplateV11;
	12: (reportTemplate: ReportTemplateV11) => ReportTemplateV12;
	13: (reportTemplate: ReportTemplateV12) => ReportTemplateLatest;
};
const migrationFns: MigrateFns = {
	2: migrateV1ToV2,
	3: migrateV2ToV3,
	4: migrateV3ToV4,
	5: migrateV4ToV5,
	6: migrateV5ToV6,
	7: migrateV6ToV7,
	8: migrateV7ToV8,
	9: migrateV8ToV9,
	10: migrateV9ToV10,
	11: migrateV10ToV11,
	12: migrateV11ToV12,
	13: migrateV12ToV13,
};

export const latestVersion = Number(Object.keys(migrationFns).at(-1)!);
export type ReportTemplateUnion =
	| ReportTemplateV1
	| ReportTemplateV2
	| ReportTemplateV3
	| ReportTemplateV4
	| ReportTemplateV5
	| ReportTemplateV6
	| ReportTemplateV7
	| ReportTemplateV8
	| ReportTemplateV9
	| ReportTemplateV10
	| ReportTemplateV11
	| ReportTemplateV12
	| ReportTemplateLatest;

export function migrateToLatest(reportTemplate: ReportTemplateUnion): ReportTemplateLatest {
	let currentReportTemplate = reportTemplate;

	for (let v = reportTemplate.data.version + 1; v <= latestVersion; v++) {
		currentReportTemplate = migrationFns[v as keyof MigrateFns](currentReportTemplate as any);
	}

	return currentReportTemplate as ReportTemplateLatest;
}
